import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

// MUI Components
import {
  Box,
  Button,
  Paper,
  Typography,
  Stack,
  useTheme,
  Container
} from "@mui/material";
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'; // Icon for 404
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';

const NotFound = () => {
  const { t } = useLanguage();
  const theme = useTheme();
  const navigate = useNavigate();

  // The centering is handled by App.js for pages like this (auth-page class)
  // So, PageContainer might not be needed here if App.js's main style is sufficient.
  // However, using a Container here ensures max-width and consistent centering if App.js styles change.

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', py: { xs: 4, sm: 8 } }}>
      <Paper
        elevation={0}
        variant="outlined" // Use outlined for a less intrusive look on error pages
        sx={{
          p: { xs: 3, sm: 5 },
          borderRadius: theme.shape.borderRadius * 1.5,
          // bgcolor: alpha(theme.palette.background.paper, 0.7),
          // backdropFilter: 'blur(10px)', // Optional: frosted glass effect
        }}
      >
        <ReportProblemOutlinedIcon sx={{ fontSize: 80, color: theme.palette.warning.main, mb: 2 }} />

        <Typography
          variant="h1"
          component="h1"
          fontWeight="bold"
          sx={{
            fontSize: { xs: '6rem', sm: '8rem' },
            color: theme.palette.text.disabled, // Muted color for 404
            lineHeight: 1,
            mb: 1,
          }}
        >
          404
        </Typography>

        <Typography variant="h4" component="h2" fontWeight="medium" sx={{ mb: 2 }}>
          {t("pageNotFound", "Oops! Page Not Found.")}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t("pageNotFoundMessage", "Sorry, the page you are looking for does not exist or has been moved.")}
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            sx={{ borderRadius: theme.shape.borderRadius * 3 }} // Pill shape
          >
            {t("goToDashboard", "Go to Dashboard")}
          </Button>
          <Button
            onClick={() => navigate(-1)} // Go back to previous page
            variant="outlined"
            color="secondary"
            size="large"
            startIcon={<ArrowBackIcon />}
            sx={{ borderRadius: theme.shape.borderRadius * 3 }} // Pill shape
          >
            {t("goBack", "Go Back")}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default NotFound;
